import React, { useState, useEffect } from "react";
import { connect, useDispatch,useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Icon } from 'react-icons-kit';
import { userPlus } from 'react-icons-kit/fa/userPlus'
import { sellsy } from 'react-icons-kit/fa/sellsy'
import { list } from 'react-icons-kit/fa/list'
import { dollar } from 'react-icons-kit/fa/dollar'
import { Column } from '@ant-design/charts';
import { Pie } from '@ant-design/charts';
import { Line } from '@ant-design/charts';
import { getPendingJobs } from '../../actions/adminDashboard';
import PendingJobModal from "./pendingJobModal";
import { getTotalUsers , countUsersfromDate , countUsersfromCountry , countUsersfromCountrychart, getTotalUsersCharts, getGoogleAnalyticsReport} from '../../actions/auth';
import { Country, State, City }  from 'country-state-city';
import axios from "axios";

import { getWallet } from '../../actions/wallet';


const AdminDashboard = (
  { auth: { 
    isAuthenticated, 
    user , 
    count , 
    charts_counter,
    totaluserscharts_counter,
    bydateUsers, 
    bycountryUsers,
    googleAnalyticsReport
  },
    getdateUsers,
    pendingJobs, 
    pendingJobs2, 
    getPendingJobs, 
    getTotalUsers , 
    countUsersfromCountrychart, 
    getTotalUsersCharts,
    // googleAnalyticsReport
  }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const wallet = useSelector(state => state.wallet);
  const [currentJob, setCurrentJob] = useState(false);
  const [modal,setModal] = useState(false);
  const [showdateresult,setShowdateresult] = useState(false);
  const [showdateresultcountry,setShowdateresultcountry] = useState(false);
  const [config,setConfig] = useState({
    data: [],
    isGroup: true,
    xField: 'xfieldData',
    yField: 'yfieldData',
    seriesField: 'name',
    label: {
      position: 'middle',
      layout: [
        { type: 'interval-adjust-position' },
        { type: 'interval-hide-overlap' },
        { type: 'adjust-color' },
      ],
    },
  });
  const [freelancerConfigPie,setFreelancerConfigPie] = useState({
    appendPadding: 10,
    data: [],
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      type: 'outer',
      content: '{name} {percentage}',
    },
    interactions: [{ type: 'pie-legend-active' }, { type: 'element-active' }],
  });
  const [clientConfigPie,setClientConfigPie] = useState({
    appendPadding: 10,
    data: [],
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      type: 'outer',
      content: '{name} {percentage}',
    },
    interactions: [{ type: 'pie-legend-active' }, { type: 'element-active' }],
  });
  // const [countrycharts, setCountrychart] = useState([]);
  const [Userchart, setUserchart] = useState([]);


  //dispatch(countUsersfromCountrychart());

  useEffect(() => {
    document.title = 'Dashboard';
    countUsersfromCountrychart();
    dispatch(getGoogleAnalyticsReport());
  }, []);

  useEffect(() => {
    getTotalUsersCharts().then(data => {
      setUserchart([data])
      //setCountbydate([data]);
      }
    )
}, []);

useEffect(()=>{

  if(Userchart.length > 0){
  
    function transformData(data) {
      
      // This will hold our transformed data
      var transformedData = [];
      
      // We will go through each item in the data array
      for (var i = 0; i < data.length; i++) {
          // For each object, we create a new object with the mapped data
          var newItem = {
              name: data[i].name,
              xfieldData: data[i].xfieldData,
              yfieldData: data[i].yfieldData
          };
          //console.log(newItem)
          // We add this new object to our transformedData array
          transformedData.push(newItem);
      }
    
      return transformedData;
    }
    
    var transformedData = transformData(totaluserscharts_counter);
    
  
    
    setConfig({
      data: transformedData,
      isGroup: true,
      xField: 'xfieldData',
      yField: 'yfieldData',
      seriesField: 'name',
      label: {
        position: 'middle',
        layout: [
          { type: 'interval-adjust-position' },
          { type: 'interval-hide-overlap' },
          { type: 'adjust-color' },
        ],
      },
    });
  
  }
},[Userchart])


  useEffect(()=>{
    if(charts_counter?.freelancerCountryCharts?.length > 0 || charts_counter?.clientCountryCharts?.length > 0){
    
      // Assume newData is the response you get
      function transformData(charts_counter) {
        
        // This will hold our transformed data
        let transformedData = [];
        
        // We will go through each inner array in the outer array
        for (var i = 0; i < charts_counter.length; i++) {
            var newItem = {
                type: charts_counter[i]._id,
                value: charts_counter[i].count
            };
            //console.log(newItem)
            // We add this new object to our transformedData array
            transformedData.push(newItem);
        }
    
        return transformedData;
      }
    
      var transformedFreelancerData = transformData(charts_counter?.freelancerCountryCharts);
      var transformedClientData = transformData(charts_counter?.clientCountryCharts);
      
      setFreelancerConfigPie({
        appendPadding: 10,
        data: transformedFreelancerData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.8,
        label: {
          type: 'outer',
          content: '{name} {percentage}',
        },
        interactions: [{ type: 'pie-legend-active' }, { type: 'element-active' }],
      });

      setClientConfigPie({
        appendPadding: 10,
        data: transformedClientData,
        angleField: 'value',
        colorField: 'type',
        radius: 0.8,
        label: {
          type: 'outer',
          content: '{name} {percentage}',
        },
        interactions: [{ type: 'pie-legend-active' }, { type: 'element-active' }],
      });
    
    }
  },[charts_counter])



  useEffect(() => {
    if (isAuthenticated && user.type === "Admin") {
      getPendingJobs();
    } else {
      history.push('/');
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    dispatch(getWallet());
  }, []);

const MAX_LENGTH = 250;
  

  const [formData , setFormData] = useState({
    from: "",
    to: "",
    country: ""
  });

  const { from, to, country} = formData;
 

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onCountryChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }
  

  
  useEffect(() => {
    if (isAuthenticated && user.type === "Admin") {
      getPendingJobs();
    } else {
      history.push('/');
    }
  }, [isAuthenticated, user]);



  const [counter, setCount] = useState([]);
  // const [countbydate, setCountbydate] = useState([]);
  const countries = Country.getAllCountries();
  // const [countOfCountry, setCountOfCountry] = useState([]);
  
 
  useEffect(() => {
    if (isAuthenticated && user.type === "Admin") {
      getTotalUsers().then(data => {
        setCount([data]);
      })
      .catch(error => {
        console.error('Error fetching count data:', error);
      });
    } },[]);
 


  //const MAX_LENGTH = 250;
  //debugger;
  //pendingJobs = JSON.parse(localStorage.getItem('pendingjobs'))
 
  //console.log(pendingJobs2.le);

  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const totalPages = Math.ceil(pendingJobs2.length / resultsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = startIndex + resultsPerPage;
  const currentResults = [...pendingJobs2].slice(startIndex, endIndex);

  const handleSearch = async() => {
    if(showdateresult == true){
      setShowdateresult(false);
    }
    else{
      setShowdateresult(true);
      if(from && to){
        const data = {
          fromDate: from,
          toDate: to,
        };
        dispatch(countUsersfromDate(data));
      }
     
    }
  }

  const handleSearchCountry = () => {
    if(showdateresultcountry == true){
      setShowdateresultcountry(false);
    }
    else{
      setShowdateresultcountry(true);
      if(country){
        const data = {
          CountryUsers: country,
        };
        dispatch(countUsersfromCountry(data));
      }
     
    }
    
  }

  var dataLastMonthSale = [
    {
      year: 'Jan',
      value: 1000,
    },
    {
      year: 'Feb',
      value: 1500,
    },
    {
      year: 'Mar',
      value: 3500,
    },
    {
      year: 'Apr',
      value: 5000,
    },
    {
      year: 'May',
      value: 4900,
    },
    {
      year: 'June',
      value: 6000,
    },
    {
      year: 'July',
      value: 7000,
    },
    {
      year: 'Aug',
      value: 9000,
    },
    {
      year: 'Sep',
      value: 13000,
    },
  ];
  
  var configLastMonthSale = {
    data: dataLastMonthSale,
    xField: 'year',
    yField: 'value',
    label: {},
    point: {
      size: 5,
      shape: 'diamond',
      style: {
        fill: 'white',
        stroke: '#5B8FF9',
        lineWidth: 2,
      },
    },
    tooltip: { showMarkers: false },
    state: {
      active: {
        style: {
          shadowBlur: 4,
          stroke: '#000',
          fill: 'red',
        },
      },
    },
    interactions: [{ type: 'marker-active' }],
  };
  
  var dataLastWeekSale = [
    {
      year: 'week1',
      value: 3000,
    },
    {
      year: 'week2',
      value: 4000,
    },
    {
      year: 'week3',
      value: 3500,
    },
    {
      year: 'week4',
      value: 5000,
    }
  ];
  
  var configLastWeekSale = {
    data: dataLastWeekSale,
    xField: 'year',
    yField: 'value',
    label: {},
    point: {
      size: 5,
      shape: 'diamond',
      style: {
        fill: 'white',
        stroke: '#5B8FF9',
        lineWidth: 2,
      },
    },
    tooltip: { showMarkers: false },
    state: {
      active: {
        style: {
          shadowBlur: 4,
          stroke: '#000',
          fill: 'red',
        },
      },
    },
    interactions: [{ type: 'marker-active' }],
  };

  
  return (
    <React.Fragment>
      <div className="main-page second py-5">
        <div className="container-fluid">
          <div className="">
            <div className="d-flex align-items-center p-3 bg-white rounded shadow-sm h5 m-0">
              <b>Admin Dashboard</b>
              <div className="ml-auto d-flex align-items-center h5 m-0 text-muted">
                Name
              </div>
            </div>
            
            <div className="row p-3 mb-0">
            { counter.length > 0 ?
              <div className="p-4 col-md-3 bg-white rounded shadow-sm">
                <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={userPlus} /> Total Users
                </h6>
                <h3 className="m-0 text-center text-muted">{counter.length > 0 ? count[0]:count[0]==0? 0: "N/A"}</h3>
                <br></br>

                <div className="d-flex align-items-center">
                <h7 className="mb-2 font-weight-bold">
                  <Icon size={30} className="mr-3" icon={userPlus} /> Total Clients:   
                </h7>
                <h7 className="mb-2 font-weight-bold" style={{ marginLeft: '10px' }}>
                  {counter.length > 0 ? count[3] : +count[3] === 0 ? 0 : "N/A"}
                </h7>
                </div>

                <div className="d-flex align-items-center">
                <h7 className="mb-2 font-weight-bold"><Icon size={30} className="mr-3" icon={userPlus} /> Total Experts: 
                </h7>
                <h7 className="mb-2 font-weight-bold" style={{ marginLeft: '10px' }}>{counter.length > 0 ? count[4]:count[4]==0? 0: "N/A"}</h7>
                </div>
              </div>
                
            : <div className="p-4 col-md-3 bg-white rounded shadow-sm">
            <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={userPlus} /> Total Users
            </h6>
            <h6 className="m-0 text-center text-muted">{"N/A"}</h6>
            </div>}
            { counter.length > 0 ?
              <div className="p-4 col-md-3 bg-white rounded shadow-sm">
                <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={sellsy} /> Today's Registrations
                </h6>
                <h3 className="m-0 text-center text-muted">{counter.length > 0 > 0 ? count[1]: count[1]==0? 0: "N/A"}</h3>
              </div>
            : <div className="p-4 col-md-3 bg-white rounded shadow-sm">
            <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={sellsy} /> Today's Registrations
            </h6>
            <h6 className="m-0 text-center text-muted">{"N/A"}</h6>
          </div>}
            { counter.length > 0 ?
              <div className="p-4 col-md-3 bg-white rounded shadow-sm">
                <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={list} /> Weekly Registrations
                </h6>
                <h3 className="m-0 text-center text-muted">{counter.length > 0  > 0 ? count[2]:count[2]==0? 0: "N/A"}</h3>
              </div>
            : <div className="p-4 col-md-3 bg-white rounded shadow-sm">
            <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={sellsy} /> Weekly Registrations
            </h6>
            <h6 className="m-0 text-center text-muted">{"N/A"}</h6>
          </div>} 
            { counter.length > 0 ? 
              <div className="p-4 col-md-3 bg-white rounded shadow-sm">
                <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={dollar} /> CybertoCyber Digital Wallet
                </h6>
                <h3 className="m-0 text-center text-muted">${wallet?.walletAmount ?? 0}</h3>
              </div>
            : <div className="p-4 col-md-3 bg-white rounded shadow-sm">
            <h6 className="mb-2 font-weight-bold"><Icon size={42} className="mr-3 text-primary" icon={sellsy} /> CybertoCyber Digital Wallet
            </h6>
            <h6 className="m-0 text-center text-muted">{"N/A"}</h6>
          </div>}
            </div>
           
             
            <div className="row p-3">
              
              {Userchart.length > 0 ? 
                <div className="col-lg-12 bg-white rounded shadow-sm p-4">
                  <h5>User Registrations Graph </h5>
                  <Column {...config} />
                </div>
              : <></>}
              
            </div>
            <div className="row p-3">
              {charts_counter?.freelancerCountryCharts?.length > 0 ? 
                <div className="col-md-6 bg-white rounded shadow-sm p-4">
                  <h5>Experts Registration By Countries</h5>
                  <Pie {...freelancerConfigPie} />
                </div>
                : <></>}
                {charts_counter?.freelancerCountryCharts?.length > 0 ? 
                <div className="col-md-6 bg-white rounded shadow-sm p-4">
                  <h5>Client Registration By Countries</h5>
                  <Pie {...clientConfigPie} />
                </div>
                : <></>}
            </div>
            {/**<div className="row p-3">
              <div className="col-md-6 bg-white rounded shadow-sm p-4">
                <h6>Last Months Sales</h6>
                <p className="text-danger font-weight-bold">$40250</p>
                <Line {...configLastMonthSale} />
              </div>
              <div className="col-md-6 bg-white rounded shadow-sm p-4">
                <h6>Last Weeks Sales</h6>
                <p className="text-primary font-weight-bold">$10250</p>
                <Line {...configLastWeekSale} />
              </div>
            </div> */}
            
            <div className="row p-3">
               
              <div className="col-md-6 bg-white rounded shadow-sm p-4">
                <h6 className="mb-3">Filter Registration By Date</h6>
                {showdateresult == false ? 
                <div>
                <h6 className="mb-3">From:</h6>
                <input type="date" className="form-control"
                  name="from"
                  value={from}
                  onChange={(e) => onChange(e)} />
           
             
              <br></br>
              
                <h6 className="mb-3">To:</h6>
                <input type="date" className="form-control"
                  name="to"
                  value={to}
                  onChange={(e) => onChange(e)} />

              <br></br>
          
              </div> 
              : 
              bydateUsers?.length > 0?  
              <div className="mt-5 p-5">
              <h2 className="text-primary text-center mb-0">{"Total: "+bydateUsers[0]}</h2>
              <h4 className="text-primary text-center mb-0">{"Clients: "+bydateUsers[3]+"  &  "+"Experts: "+bydateUsers[4]}</h4>
              <p className="text-primary text-center mb-0">{"Registrations From: "+bydateUsers[1]+" To: "+bydateUsers[2]}</p>
              </div>
               :
              <div className="mt-5 p-5">
              <h6 className="text-primary text-center mb-0">N/A.</h6>
              </div> 
              }  
              {showdateresult == false ?
               <button className="btn btn-default mr-1" onClick={handleSearch} >Filter</button> 
              : <button className="btn btn-default mr-1" onClick={handleSearch}>Back</button> 
              }
              </div>

              
              
              <div className="col-md-6 bg-white rounded shadow-sm pt-4 pb-4">
             
                <h6 className="mb-3">Find Registrations by Country</h6>
                  {showdateresultcountry == false ?
                  <div>
                  
                  <select className="form-control"
                    name="country"
                    value={country}
                    onChange={(e) => onCountryChange(e)}>
                      <option>Select Country</option>
                  {
                    countries.map(item => <option value={item.name} data-isoCode={item.isoCode}>{item.name}</option> )
                  }
                  </select>
                  <br></br>
                  </div>
                   :
                   bycountryUsers.length > 0 ?
                   <div className="mt-5 p-5">
                    <h2 className="text-primary text-center mb-0">{"Total: "+bycountryUsers[2]}</h2>
                    <h4 className="text-primary text-center mb-0">{"Clients: "+bycountryUsers[1]+"  &  "+"Experts: "+bycountryUsers[0]}</h4>
                    <p className="text-primary text-center mb-0">{"Registrations from Country: "+bycountryUsers[3]}</p>
                   </div> 
                   :
                   <div className="mt-5 p-5">
                  <h6 className="text-primary text-center mb-0">N/A.</h6>
                  </div> }  
                   {showdateresultcountry == false ?
                    <button className="btn btn-default mr-1" onClick={handleSearchCountry} >Filter</button> 
                   : <button className="btn btn-default mr-1" onClick={handleSearchCountry}>Back</button> 
                   }
              
              </div>

             
            </div>

            <div className="col-12">
                <h3>Google analytics report</h3>
                <div className="border pt-4 pl-5 pe-5 pb-5 rounded mt-4" style={{position: 'relative'}}>
                  <p style={{position: 'absolute', top: '-18px', backgroundColor:'white', padding: '4px', fontSize:'20px', left: '30px' }}>Summary</p>
                  <div className="row">
                    <div className="col-lg-2">
                        <p>Active Users</p>
                        <p style={{fontSize: "36px"}}>{googleAnalyticsReport?.activeUsers}</p>
                    </div>
                    <div className="col-lg-2">
                        <p>New Users</p>
                        <p style={{fontSize: "36px"}}>{googleAnalyticsReport?.newUsers}</p>
                    </div>
                    <div className="col-lg-2">
                        <p>Total Pages Views</p>
                        <p style={{fontSize: "36px"}}>{googleAnalyticsReport?.totalPageViews}</p>
                    </div>
                    <div className="col-lg-2">
                        <p>Page View Per User <sub>avg</sub></p>
                        <p style={{fontSize: "36px"}}>{googleAnalyticsReport?.pageViewsPerUser}</p>
                    </div>
                    <div className="col-lg-2">
                        <p>Total Event Counts</p>
                        <p style={{fontSize: "36px"}}>{googleAnalyticsReport?.totalEventCounts}</p>
                    </div>
                    <div className="col-lg-2">
                        <p>Event Counts Per User <sub>avg</sub> </p>
                        <p style={{fontSize: "36px"}}>{googleAnalyticsReport?.eventCountsPerUser}</p>
                    </div>
                  </div>
                </div>
                <div className="mt-5" style={{position: 'relative'}}>
                  <p style={{position: 'absolute', top: '-18px', backgroundColor:'white', padding: '4px', fontSize:'20px', left: '30px'}}>Top Pages</p>
                  <div className="border px-4 py-4 rounded mt-4">
                    <table class="table table-borderless table-hover">
                      <thead>
                        <tr>
                          <th scope="col">Page path</th>
                          <th scope="col">Views</th>
                          <th scope="col">Active Users</th>
                        </tr>
                      </thead>
                      <tbody>
                        {googleAnalyticsReport?.mostViewedPages?.map((pageDetails, index)=>{
                          return (
                            <tr>
                              <td>{pageDetails?.pagePath}</td>
                              <td>{pageDetails?.pageViews}</td>
                              <td>{pageDetails?.activeUsers}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <hr />
            <div className="row p-3">

              <div className="col-12 bg-white rounded shadow-sm p-4">
                  <h6 className="mb-3">Pending Job requests</h6>
                  {
                  currentResults.length > 0 ?  
                  currentResults.length > 0 && [...currentResults].reverse().map((job) => (
                    <div onClick={()=>{ setModal(!modal); setCurrentJob(job)}} className="row mt-3 border border-primary p-3 bg-white">
                    <div className="col-md-12 pt-1">
                        <span className="cursorClass">
                            <div className="d-flex justify-content-between">
                              <h6 className="text-primary mb-0">{"Job Tile: "+job.headline}</h6>
                              <p><span className="font-weight-bold">Posted:</span> {job.job_post_time.split('T')[0]} </p>
                             
                            </div>
                            <div className="d-flex justify-content-between">
                            <p className="mb-0"><span className="font-weight-bold">Payment Type: {job.payment_amount+" $"}</span> {job.payment_type_id == "61090602da79aa25b4318b49" ? "-- Fixed Amount Project" : "/ hr"} </p>
                              <p><span className="font-weight-bold">Status:</span> <span className="text-muted">{job.status}</span></p>
                            </div>
                            <p className="font-weight-bold mb-3">{"Job Description: "+job.description}</p>
                        </span>
                    </div>
                </div>
                  )): 
                  <div className="mt-5 p-5">
                  <h6 className="text-primary text-center mb-0">No Pending Jobs Found</h6>
                 </div>} 
                </div>
            </div>

               
             {/* Display the navigation buttons */}
             {totalPages > 1 && (
                <nav>
                  <ul className="pagination justify-content-center">
                      {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      return (
                          <li key={pageNumber} className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}>
                          <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                              {pageNumber}
                          </button>
                          </li>
                      );
                      })}
                  </ul>
                </nav>
              )}
          </div>
        </div>
      </div>
      <PendingJobModal modal={modal} setModal={setModal} currentJob={currentJob}/>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  pendingJobs: state.adminDashboard.pendingJobs,
  pendingJobs2: state.adminDashboard.pendingJobs2,
  getdateUsers : state,
});

export default connect(mapStateToProps, { getPendingJobs , getTotalUsers , countUsersfromDate , countUsersfromCountry , countUsersfromCountrychart, getTotalUsersCharts})(AdminDashboard);
